import {AfterViewInit, Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {hideGlobalSpinner} from '../layout-shell.utils';

@Component({
	standalone: false,
	selector: 'ngx-three-columns-layout',
	styleUrls: ['./three-columns.layout.scss'],
	template: `
		<div class="app-layout app-layout-window">
			<div class="app-layout-body">
				<app-sidebar tag="menu-sidebar">
					<ng-content select="app-menu"></ng-content>
				</app-sidebar>

				<div class="app-layout-main">
					<header class="app-layout-header">
						<ngx-header></ngx-header>
					</header>

					<div class="app-layout-content app-layout-content--split">
						<main class="app-layout-column small"></main>
						<main class="app-layout-column">
							<ng-content select="router-outlet"></ng-content>
						</main>
						<main class="app-layout-column small"></main>
					</div>

					<footer class="app-layout-footer">
						<ngx-footer></ngx-footer>
					</footer>
				</div>
			</div>
		</div>
	`,
})
export class ThreeColumnsLayoutComponent implements AfterViewInit {
	constructor(@Inject(DOCUMENT) private readonly document: Document) {
	}

	ngAfterViewInit(): void {
		hideGlobalSpinner(this.document);
	}
}
